/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var HandThumbDownIcon20Solid = forwardRef('HandThumbDownIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "m13 12-3.142 6.174A1.51 1.51 0 0 1 7 17.49V13H3.319a2.25 2.25 0 0 1-2.194-2.749l1.278-5.624A3.375 3.375 0 0 1 5.694 2H13v10Z" }),
        React.createElement("path", { d: "M16.5 12a1.5 1.5 0 0 0 1.5-1.5v-7A1.5 1.5 0 0 0 16.5 2H14v10h2.5Z" })));
});
